
<template>
  <b-container class="py-4">
    <ValidationObserver ref="observer">
      <b-form @submit.prevent="confirmData">
        <h5>Modalidad de participación</h5>
        <b-row>
          <b-col md="6">
            <label>Modalidad</label>
            <b-form-select v-model="form.modalidad" :options="modalidades" @change="actualizarValor"/>
          </b-col>
          <b-col md="6">
            <label>Categoría</label>
            <b-form-select v-model="form.categoria" :options="categorias" @change="actualizarValor"/>
          </b-col>
        </b-row>

        <hr>
        <h5>Datos del participante</h5>

        <b-row>
          <b-col md="6">
            <label>Tipo documento</label>
            <b-form-select v-model="form.tipodocumento" :options="tiposDocumento"/>
          </b-col>
          <b-col md="6">
            <label>No. documento</label>
            <b-form-input v-model="form.document"/>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <label>Nombres y apellidos</label>
            <b-form-input v-model="form.nombre"/>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="4"><label>Correo</label><b-form-input v-model="form.buyerEmail"/></b-col>
          <b-col md="4"><label>Teléfono</label><b-form-input v-model="form.telefono"/></b-col>
          <b-col md="4"><label>Institución</label><b-form-input v-model="form.institucion"/></b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="6"><label>Ciudad / País</label><b-form-input v-model="form.ciudadPais"/></b-col>
        </b-row>

        <hr>
        <h5>Datos del pagador</h5>

        <b-form-checkbox v-model="mismoPagador" @change="copiarDatosPagador">
          El participante realiza el pago
        </b-form-checkbox>

        <b-row class="mt-2">
          <b-col md="6"><label>Tipo documento</label><b-form-select v-model="form.tipoDocumentoPago" :options="tiposDocumento"/></b-col>
          <b-col md="6"><label>No. documento</label><b-form-input v-model="form.documentoPago"/></b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col><label>Nombre completo</label><b-form-input v-model="form.nombrePago"/></b-col>
        </b-row>

        <hr>
        <b-card>
          <p><strong>Modalidad:</strong> {{form.modalidad}}</p>
          <p><strong>Categoría:</strong> {{form.categoria}}</p>
          <h4>Total: $ {{ Number(form.amount||0).toLocaleString('es-CO') }}</h4>
        </b-card>
        <hr/>
        <b-button class="col-md-12" variant="primary" type="submit">
          Confirmar pago
        </b-button>
      </b-form>
    </ValidationObserver>
  </b-container>
</template>

<script>
    import MD5 from "crypto-js/md5";
    import IberoHelpers from '@/store/helpers.js'

export default {
 data(){
  return{
   mismoPagador:false,
   modalidades:[
    {value:null,text:"Seleccione"},
    {value:"Presencial",text:"Presencial"},
    {value:"Virtual",text:"Virtual"}
   ],
   categorias:[
    {value:null,text:"Seleccione"},
    {value:"Estudiante Ibero",text:"Estudiante Ibero"},
    {value:"Estudiante externo",text:"Estudiante externo"},
    {value:"Profesional",text:"Profesional"}
   ],
   tiposDocumento:[
    {value:null,text:"Seleccione"},
    {value:"CC",text:"Cédula de ciudadanía"},
    {value:"TI",text:"Tarjeta identidad"},
    {value:"CE",text:"Cédula extranjería"},
    {value:"PS",text:"Pasaporte"}
   ],
   precios:{
    Presencial:{"Estudiante Ibero":60000,"Estudiante externo":90000,"Profesional":150000},
    Virtual:{"Estudiante Ibero":50000,"Estudiante externo":70000,"Profesional":120000}
   },
   form:{
    modalidad:null,categoria:null,amount:0,
    tipodocumento:null,document:null,nombre:null,buyerEmail:null,telefono:null,
    institucion:null,ciudadPais:null,
    tipoDocumentoPago:null,documentoPago:null,nombrePago:null
   }
  }
 },
methods:{
    actualizarValor(){
        if(this.form.modalidad && this.form.categoria){
            this.form.amount=this.precios[this.form.modalidad][this.form.categoria];
        }
    },
    copiarDatosPagador(){
        if(!this.mismoPagador) return;
        this.form.tipoDocumentoPago=this.form.tipodocumento;
        this.form.documentoPago=this.form.document;
        this.form.nombrePago=this.form.nombre;
    },
    async confirmData() {

    const valid = await this.$refs.observer.validate();

    if (!valid)
        return;

    const ref = this.form.document + Date.now();

    this.form.referenceCode = ref;

    const cadena =
        "1114849ee52~14717~" +
        ref +
        "~" +
        this.form.amount +
        "~COP";

    const data = {
        idEvent: "1",
        documentType: this.form.tipodocumento,
        documentNumber: this.form.document,
        fullName: this.form.nombre,
        email: this.form.buyerEmail,
        telephoneNumber: this.form.telefono,
        eventValue: `${this.form.amount}`,
        studentCode: "",
        studentType: this.form.categoria,
        address: this.form.direccion || "",
        country: this.form.ciudadPais || "",
        payerDocumentType: this.form.tipoDocumentoPago,
        payerDocumentNumber: this.form.documentoPago,
        payerFullName: this.form.nombrePago,
        payerEmail: this.form.emailPago || "",
        payerTelephoneNumber: this.form.telefonoPago || ""
    };

    let event = IberoHelpers.sendEvent(this.$store, data);

    event.then(Response => {

        if (Response === false) {
            this.$dialog.alert("No fue posible registrar el evento.");
            return;
        }
        this.sendPayU();
    });
    },

    sendPayU() {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://gateway.payulatam.com/ppp-web-gateway";
        const apiKey = "1114849ee52";
        const merchantId = "14717";
        const date = new Date();
        const referenceCode = this.form.document + date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0');
        const cadena = `${apiKey}~${merchantId}~${referenceCode}~${this.form.amount}~COP`;

        const signature = MD5(cadena).toString();
        const values = {
            merchantId: merchantId,
            accountId: "18717",
            description: "PagosIbero",
            referenceCode: referenceCode,
            amount: this.form.amount,
            tax: "0",
            taxReturnBase: "0",
            currency: "COP",
            signature: signature,
            test: "0",
            buyerEmail: this.form.buyerEmail,
            buyerFullName: this.form.nombre,
            telephone: this.form.telefono,
            payerDocument: this.form.document
        };
        Object.keys(values).forEach(key => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = values[key];
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
    }
 }
}
</script>
<style scope>
.FormInscripcion {
  background-color: #fff;
}

.FormInscripcionOK .wizard-card-footer{
  display: none;
}

.row
{
  display: flex;
  flex-wrap: wrap;
}

.totalform {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #fff;
}

.wizard-progress-with-circle {
  display: none !important;
}

.wizard-nav-pills, .wizard-card-footer{
  margin-left: 10% !important;   
  margin-right: 10% !important;
} 

.vue-form-generator, fieldset{
  display: contents;
}

.linkref{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}

#div_IdICFESText{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -20px;
}

#div_IdAddressNumTxt, #div_IdAddressRefTxt{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}


.linkref a{
  color: #222 !important;
}

.active
{
  color: #222;
}

.noShow{
  display: none;
}

#div_IdTermiCondi .titleRef, #div_IdHomolo .titleRef, #div_IdComproMatricula .titleRef{
  color: #ffffff;
  margin-top: 10px;
  font-size: 20px;
}

.infoForm .colRefForm div
{
  color: #000;
}

.titleRefSumary{
  font-weight: bold;
  text-transform: uppercase;
  text-decoration-line: underline;
  margin-top: 20px;
  margin-bottom: 20px;
}

.titleSumary{
    font-weight: bold;
}

.listSumary{
  font-size: 13px;
}
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.botonPay {
  margin-top: 5px;
  max-width: 250px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.detalleAddress .is-invalid-form{
  display: none;
}

#sum_IdOperator, #sum_IdICFESText{
  display: none;
}

.botonData{
  margin-right: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}

body {
    background:  #fff;   
}
header {
    background:  #fff;
}

#IdMonthSelect{
  top: 52px;
}

#error_IdMonthSelect{
  margin-top: 55px;
}

#IdYearSelect{
  top: 52px;
}

#IdDaySelectBirth{
  top: 11px;
}

#error_IdYearSelect{
  margin-top: 55px;
}

#IdMonthSelectBirth{
  top: 52px;
}

#error_IdMonthSelectBirth{
  margin-top: 55px;
}

#IdYearSelectBirth{
  top: 52px;
}

#error_IdYearSelectBirth{
  margin-top: 55px;
}
#IdMonthSelectReq{
  top: 52px;
}

#error_IdMonthSelectReq{
  margin-top: 55px;
}

#IdYearSelectReq{
  top: 52px;
}

#error_IdYearSelectReq{
  margin-top: 55px;
}

.col2 {
    flex-basis: none !important;
} 

</style>